// Translations
import message from '../sections/message/translations/ar'

// Translation: Error > Landing (Arabic)
export default Object.freeze({
	sections: { message }
})
